import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import MapaIntegradoPublico from './MapaIntegradoPublico';

/**
 * Componente wrapper para o mapa público que adiciona metadados e configurações específicas
 * para a página pública.
 */
const MapaPublicoWrapper = () => {
  useEffect(() => {
    console.log("MapaPublicoWrapper renderizado");
  }, []);

  return (
    <>
      <Helmet>
        <title>Mapa de Obras Públicas - Prefeitura Teste</title>
        <meta name="description" content="Visualize as obras públicas em andamento no município de Conceição do Castelo - ES" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Mapa de Obras Públicas" />
        <meta property="og:description" content="Visualize as obras públicas em andamento no município de Conceição do Castelo - ES" />
        <meta property="og:type" content="website" />
      </Helmet>
      <MapaIntegradoPublico />
    </>
  );
};

export default MapaPublicoWrapper;